import { graphql } from 'react-apollo';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import _get from 'lodash/get';
import RoomSystem from 'components/RoomSystem/RoomSystem';
import { featureSelectors } from '@lifesize/nucleus';
import { Global } from 'state/Global';
import {
  FEATURE_FLAG_ROOM_SYSTEM_MAINTENANCE_TAB,
  FEATURE_FLAG_DASH_CALENDAR,
  FEATURE_FLAG_CONNECT_TABLET_TO_ICON,
  FEATURE_FLAG_ROOM_SYSTEM_UPGRADE_MANAGEMENT,
  FEATURE_FLAG_ROOM_SYSTEM_REBOOT
} from 'constants/featureFlags';
import { canConnectDevice, isPlatformIcon } from 'utils/roomSystemUtils';
import getRoomSystemQuery from 'queries/roomSystems/getRoomSystemQuery.gql';

interface ComponentProps {
  match: {
    params: {
      id: string
    };
  };
}

const mapStateToProps = (state: Global) => {
  return {
    hasMaintenanceTabFeature: featureSelectors.getFeatureFlag(state)(FEATURE_FLAG_ROOM_SYSTEM_MAINTENANCE_TAB),
    hasDashCalendarFeature: featureSelectors.getFeatureFlag(state)(FEATURE_FLAG_DASH_CALENDAR),
    hasConnectTabletToIconFeature: featureSelectors.getFeatureFlag(state)(FEATURE_FLAG_CONNECT_TABLET_TO_ICON),
    hasRoomSystemRebootFeature: featureSelectors.getFeatureFlag(state)(FEATURE_FLAG_ROOM_SYSTEM_REBOOT),
    hasRoomSystemUpgradeManagementFeature: featureSelectors.getFeatureFlag(state)(FEATURE_FLAG_ROOM_SYSTEM_UPGRADE_MANAGEMENT),
  };
};

const mapDispatchToProps = () => ({});

export default withRouter(compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  graphql(getRoomSystemQuery, {
    options: (props: ComponentProps) => {
      return {
        fetchPolicy: 'network-only',
        variables : { serialNumber: props.match.params.id }
      };
    },
    // tslint:disable-next-line
    props: ({ data, ownProps }: any) => {
      const hasMonitoringData = !!_get(data, 'getRoomSystem.deviceMonitoring.metrics');
      const hasMaintenanceTabContent = hasMonitoringData || ownProps.hasRoomSystemRebootFeature || ownProps.hasRoomSystemUpgradeManagementFeature;
      const hasMaintenanceTab = ownProps.hasMaintenanceTabFeature && isPlatformIcon(_get(data, 'getRoomSystem.platform')) && hasMaintenanceTabContent;
      return {
        ...ownProps,
        data,
        displayName: _get(data, 'getRoomSystem.displayName', ''),
        roomSystem: _get(data, 'getRoomSystem', {}),
        serialNumber: _get(ownProps.match, 'params.id'),
        hasMaintenanceTab,
        canConnectTabletToIcon: ownProps.hasConnectTabletToIconFeature && canConnectDevice(_get(data, 'getRoomSystem', {})),
        hasMonitoringData,
        deviceMonitoring: _get(data, 'getRoomSystem.deviceMonitoring'),
      };
    },
  }),
)(RoomSystem));
